<template>
  <div id="current-timezone" class="current-timezone" v-if="isTimeZoneSensitive && currentTimeZone">
    Viewing Data in <b>{{ currentTimeZone }}</b> Time Zone
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'CurrentTimezone',

  data() {
    return {
      defaultTimeZone: 'UTC',
    };
  },

  computed: {
    ...mapGetters(['userTimezone']),
    ...mapGetters('timezones', ['routeTimezone']),

    isTimeZoneSensitive() {
      return this.$store.state.route.meta && this.$store.state.route.meta.isTimeZoneSensitive;
    },

    currentTimeZone() {
      return this.routeTimezone(this.$store.state.route.name) || this.userTimezone;
    },
  },
};
</script>
